import React from "react";
import UserPage from "../../common/UserPage/UserPage";
import Footer from "../../common/Footer/Footer";
import MyWallet from "../../components/UserTherapyPlanner/MyWallet"

function MyWalletPage() {
  return (
    <div>
      <UserPage />
      <MyWallet />
      <Footer />
    </div>
  );
}

export default MyWalletPage;
